
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[...slug]",
      function () {
        return require("private-next-pages/blogs/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[...slug]"])
      });
    }
  